module.exports = __webpack_public_path__ + "img/avatar3.c60450ec.png";